import { render, staticRenderFns } from "./ci-exclusions.vue?vue&type=template&id=4defbaec&scoped=true"
import script from "./ci-exclusions.vue?vue&type=script&lang=js"
export * from "./ci-exclusions.vue?vue&type=script&lang=js"
import style0 from "./ci-exclusions.vue?vue&type=style&index=0&id=4defbaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defbaec",
  null
  
)

export default component.exports